// 首页
const Footer = () => import('@/views/home/Footer')
const Home = () => import('@/views/home/Index')
const HomeRecommend = () => import('@/views/home/Recommend')
const Order = () => import('@/views/order/Index')
const User = () => import('@/views/user/Index')
const Task = () => import('@/views/task/Index')
const GonYinShan = () => import('@/views/home/GonYinShan.vue')

import axios from '@/utils/fetch'

export default [
  {
    path: '/',
    component: Footer,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: Home,
        beforeEnter: (to, from, next) => {
          if ((/^\/home(\/)?$/gi).test(to.path)) {
            axios.get('/user/manager/userinfo').then(res => {
              console.log(res.code == '2000')    
              if (res.code == '2000') {
                if (res.data.type !== 1) {
                  next('/home/gys')
                } else {
                  next()
                }
              } else {
                next()
              }
            })
          } else {
            next()
          }
        },
        meta: {
          title: '首页'
        }
      },
      {
        path: 'order',
        component: Order,
        meta: {
          title: '订单'
        }
      },
      {
        path: '/user',
        component: User,
        meta: {
          title: '我的'
        }
      },
      {
        path: '/task',
        component: Task,
        meta: {
          title: '任务'
        }
      }
    ]
  },
  {
    path: '/home/recommend',
    component: HomeRecommend,
    meta: {
      title: '精品推荐'
    }
  },
  {
    path: '/home/gys',
    component: GonYinShan,
    meta: {
      title: '首页'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/home.js